// @ts-nocheck
import { useDebounce } from "@store/Framework/Common/Hooks/useDebounce";
import useScrollContext from "@store/Framework/Common/Hooks/useScrollContext";
import { useEffect, useMemo, useState } from "react";

export default () => {
    const [scrollInit, setScrollInit] = useState(false);
    const { setScroll } = useScrollContext();

    const handleScroll = () => {
        setScroll(document.body.scrollTop || document.documentElement.scrollTop);
    };
    const debouncedHandleScroll = useDebounce(handleScroll, 300);
    useEffect(() => {
        if (scrollInit) {
            debouncedHandleScroll();
        }
    }, [scrollInit]);

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        setScrollInit(true);

        window.addEventListener("scroll", debouncedHandleScroll);
        return () => {
            window?.removeEventListener?.("scroll", debouncedHandleScroll);
        };
    }, []);
};
